import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { LoadingButton } from '@mui/lab'
import { Box, Button, Card, Skeleton, Typography } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react'

import apiClient from '../../../api/apiClient'

interface IWorkspaceTransferDetails {
  name: string
  workspace: {
    id: string
    name: string
  }
  code: string
  transfer: string
}

function TransferAcceptInvite({
  setActiveStep,
  workspaceDetails,
}: {
  setActiveStep: Dispatch<SetStateAction<number>>
  workspaceDetails: IWorkspaceTransferDetails
}) {
  const [isLoading, setIsLoading] = useState(false)

  const acceptInvite = async () => {
    try {
      setIsLoading(true)
      await apiClient.post(
        `/workspace/${workspaceDetails.workspace.id}/ownership/transfer/${workspaceDetails.transfer}?inviteCode=${workspaceDetails.code}`,
        {
          accept: true,
        },
      )
      setActiveStep((prev) => prev + 1)
      setIsLoading(false)
    } catch (err) {
      console.error(err)
      setIsLoading(false)
    }
  }

  const declineInvite = async () => {
    try {
      await apiClient.post(
        `/workspace/${workspaceDetails.workspace.id}/ownership/transfer/${workspaceDetails.transfer}?inviteCode=${workspaceDetails.code}`,
        {
          accept: false,
        },
      )
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Box sx={{ maxWidth: '450px' }}>
      <Card sx={{ padding: '24px', borderRadius: '12px' }}>
        <Typography variant="h2" color="primary.900">
          Accept invite to transfer ownership?
        </Typography>
        {workspaceDetails.name !== '' &&
        workspaceDetails.workspace.id !== '' &&
        workspaceDetails.workspace.name !== '' ? (
          <>
            <Box sx={{ padding: '12px 0px' }}>
              <Typography variant="body1" padding="6px 0px" color="grey.500">
                <b>{workspaceDetails.name}</b> invited you to transfer the ownership of{' '}
                <b>{workspaceDetails.workspace.name}</b> workspace to you.
              </Typography>
              <Typography variant="body1" padding="6px 0px" color="grey.500">
                By accepting and continuing, you will need to add your billing details to complete the transfer and get
                the full access to <b>{workspaceDetails.workspace.name}</b> workspace.
              </Typography>
            </Box>

            <Box display="flex" justifyContent="flex-end" gap="8px">
              <Button variant="outlined" sx={{ borderColor: 'error.800', color: 'error.800' }} onClick={declineInvite}>
                Decline
              </Button>
              <LoadingButton
                variant="contained"
                loading={isLoading}
                onClick={acceptInvite}
                sx={{
                  backgroundColor: 'primary.600',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                Accept and Continue
                <ArrowForwardIcon />
              </LoadingButton>
            </Box>
          </>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', padding: '24px 0px' }}>
            <Box>
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Box>
            <Box>
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Box>
          </Box>
        )}
      </Card>
    </Box>
  )
}

export default TransferAcceptInvite
